module.exports = "/v2/pages/dashboard/dist/9153be3a9098f3061f6fa6336e6d5cec.svg";